import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { getCurrentBalance } from '@/data/api/request/disbursementsRequests';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useGetBalance() {
  const { showSnackError } = useSnackbarContext();

  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.disbursement.balance],
    queryFn: () => getCurrentBalance(),
  });

  useEffect(() => {
    if (error) showSnackError('No se pudo obtener el balance');
  }, [error]);

  return {
    data,
    isLoading,
  };
}
